var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-seo',{staticClass:"mb-10",attrs:{"data":_vm.pageHomeSeo}}),_c('featured-category',{staticClass:"mb-10"}),_c('recommendation-business',{staticClass:"mb-10"}),_c('our-partner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }